import {Box, Icon, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {BsCardChecklist} from "react-icons/bs";
import {
    MdCalendarToday,
    MdLocationCity,
    MdLocationPin,
    MdOutlinePhone,
    MdPhone,
} from "react-icons/md";
import phoneNumberFormatter from "../globalFunction/telefon";
import {CgOrganisation} from "react-icons/cg";
import {TbListNumbers} from "react-icons/tb";

const ViewClient = ({clientObj, data, type = "client", width = "100%"}) => {
    const [defaultClientObj, setDefaultClientObj] = useState([
        {
            name_uz: "F.I.SH",
            value: data?.name,
            icon: <BsCardChecklist/>,
        },
        {
            name_uz: "Kod",
            value: data?.code,
            icon: <TbListNumbers/>,
        },
        {
            name_uz: "Manzili",
            value: data.address,
            icon: <MdLocationPin/>,
        },
        {
            name_uz: "Tug'ilgan sana",
            value: data.dateOfBirth,
            icon: <MdCalendarToday/>,
        },
        {
            name_uz: "Telefon raqami",
            value: phoneNumberFormatter(data.phoneNumber),
            icon: <MdOutlinePhone/>,
        },
        {
            name_uz: "Telefon raqami 2",
            value: phoneNumberFormatter(data.phoneNumber2),
            icon: <MdPhone/>,
        },
        {
            name_uz: "Tashkilot",
            value: data.organization,
            icon: <CgOrganisation/>,
        },
        {
            name_uz: "Viloyat",
            value: data.region.name,
            icon: <MdLocationCity/>,
        },
        {
            name_uz: "Kategoriya",
            value: data.category,
            icon: <MdLocationCity/>,
        },
    ]);
    useEffect(() => {
        if (clientObj) {
            setDefaultClientObj(clientObj);
        }
    }, [clientObj]);

    return (
        <Box
            sx={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                gap: "0.5rem",
                width,
                m: "1rem auto",
            }}
        >
            <Box
                sx={{
                    backgroundColor: "action.hover",
                    padding: "0.2rem 0.5rem",
                    borderRadius: "0.5rem",
                    position: "relative",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        backgroundColor: "#0088cc30",
                        padding: "0.2rem 2rem",
                        borderRadius: "0.5rem",
                    }}
                >
                    <Typography variant="body1">
                        {type === "client" ? "Mijoz ma'lumoti" : "Savdo ma'lumoti"}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        padding: "0.2rem 2rem",
                        borderRadius: "0.5rem",
                    }}
                >
                    <Typography variant="body2">ID : {data.id}</Typography>
                </Box>
                <Box
                    sx={{
                        mt: "2rem",
                        padding: 2,
                    }}
                >
                    {defaultClientObj.map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                borderBottom: "1px solid #e0e0e0",
                                padding: "0.5rem 0",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                    width: "40%",
                                }}
                            >
                                <Icon>{item.icon}</Icon>
                                <Typography variant="caption">{item.name_uz}</Typography>
                            </Box>
                            <Typography variant="caption" width={"60%"}>
                                {item.value}
                            </Typography>
                        </Box>
                    ))}
                    {
                        clientObj.longitude && clientObj.latitude &&
                        <div>
                            <Typography variant="caption">Koordinatalar</Typography>
                            <Typography variant="caption">longitude: {clientObj.longitude}</Typography>
                            <Typography variant="caption">latitude: {clientObj.latitude}</Typography>
                        </div>
                    }
                </Box>
            </Box>
        </Box>
    );
};

export default ViewClient;
